import { api } from './client';

// ============================================
// Types
// ============================================

export interface FbInsightRow {
  date_start: string;
  account_id?: string;
  account_name?: string;
  dimension_value?: string;

  // additive (SUM)
  spend: number;
  impressions: number;
  clicks: number;
  reach: number;
  unique_clicks: number;

  // conversions (flattened)
  purchase_count: number;
  purchase_value: number;
  add_to_cart_count: number;
  initiate_checkout_count: number;
  registration_count: number;
  inline_link_clicks: number;
  inline_post_engagement: number;

  // video
  video_play_count: number;
  video_p25_watched_count: number;
  video_p50_watched_count: number;
  video_p75_watched_count: number;
  video_p100_watched_count: number;

  // ratio (calculated)
  ctr: number;
  cpc: number;
  cpm: number;
  frequency: number;
  unique_ctr: number;
  roas: number;
  cost_per_purchase: number;
  cost_per_add_to_cart: number;
  aov: number;
  cvr: number;
  add_to_cart_rate: number;
  cart_conversion_rate: number;
}

export interface FbInsightListParams {
  brand_id: string;
  site_id?: string;
  start_date: string;
  end_date: string;
  account_ids?: string;
  dimension?: string;
  ad_id?: string;
  ad_name?: string;
  campaign_name?: string;
  adset_name?: string;
  objective?: string;
  funnel_level?: string;
  funnel_detail?: string;
  customer_type?: string;
  campaign_type?: string;
  bid_strategy?: string;
  creative_type?: string;
  price_range?: string;
  product_position?: string;
  target_layer?: string;
  country_tag?: string;
  gender_tag?: string;
  attribution_model?: string;
  marketing_event?: string;
  landing_page?: string;
  page?: number;
  size?: number;
}

export interface TagOption {
  value: string;
  label: string;
}

export interface TagFilterGroup {
  key: string;
  label: string;
  options: TagOption[];
}

export interface FbInsightListResponse {
  code: number;
  message: string;
  data: {
    list: FbInsightRow[];
    total: number;
    page: number;
    size: number;
    total_page: number;
    summary: FbInsightRow | null;
  };
}

export interface AccountOption {
  account_id: string;
  account_name: string;
}

export interface DimensionOption {
  value: string;
  label: string;
}

// ============================================
// API
// ============================================

export const fbInsightsApi = {
  getList: (params: FbInsightListParams) =>
    api.get<FbInsightListResponse>('/fb-insights/list', { params }),

  getAccounts: (params: { brand_id: string; site_id?: string; scope?: 'dashboard_read' | 'dashboard_export' }) =>
    api.get<{ code: number; data: AccountOption[] }>('/fb-insights/accounts', { params }),

  getDimensions: () =>
    api.get<{ code: number; data: DimensionOption[] }>('/fb-insights/dimensions'),

  getTagOptions: (params: { brand_id: string }) =>
    api.get<{ code: number; data: TagFilterGroup[] }>('/fb-insights/tag-options', { params }),
};
